import { useContext } from 'react';
import { ToastContext, type ToastApi } from './toastContext';

export function useToast(): ToastApi {
  return useContext(ToastContext);
}
